// extracted by mini-css-extract-plugin
export default {"wrapper":"QRCode_wrapper--GAF","btn":"QRCode_btn--shh","info":"QRCode_info--A0j","infoLink":"QRCode_infoLink--zk5","img":"QRCode_img--YCP","tooltip":"QRCode_tooltip--Qob"};